import React from 'react';
import { useAppTheme } from '../../context/ThemeContext';

interface AlertProps {
  type: 'success' | 'error' | 'warning' | 'info';
  children: React.ReactNode;
  className?: string;
}

const Alert: React.FC<AlertProps> = ({ type, children, className = '' }) => {
  const { themeConfig } = useAppTheme();

  const getAlertStyles = () => {
    const baseStyles = 'p-4 rounded-lg border';
    const typeStyles = {
      success: {
        bg: themeConfig.success + '20',
        border: themeConfig.success + '40',
        text: themeConfig.success
      },
      error: {
        bg: themeConfig.error + '20',
        border: themeConfig.error + '40',
        text: themeConfig.error
      },
      warning: {
        bg: themeConfig.warning + '20',
        border: themeConfig.warning + '40',
        text: themeConfig.warning
      },
      info: {
        bg: themeConfig.primary + '20',
        border: themeConfig.primary + '40',
        text: themeConfig.primary
      }
    };

    const styles = typeStyles[type];
    return `${baseStyles} ${className} bg-[${styles.bg}] border-[${styles.border}] text-[${styles.text}]`;
  };

  return (
    <div className={getAlertStyles()}>
      {children}
    </div>
  );
};

export default Alert; 